import { useQuery, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "../queryKeys";
import { portalApiClient } from "../apiClient";

export function useCompanyApis(companyId: string | number) {
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey: [queryKeys.companies, companyId],
    queryFn: async () => {
      const apiUrl = `/api/Apis/GetByCompanyId/${companyId}`;
      const rs = await portalApiClient.get(apiUrl);
      return rs.data;
    },
  });
  return {
    ...query,
    invalidate: queryClient.invalidateQueries({
      queryKey: [queryKeys.companies, companyId],
    }),
  };
}
